import TOR_STATUSES, { TOR_STATUS_LABELS } from './TOR_STATUSES';

export default [
  {
    id: TOR_STATUSES.PENDING_APPROVAL,
    text: TOR_STATUS_LABELS[TOR_STATUSES.PENDING_APPROVAL],
    to: '/time-off-requests/pending-approval',
  },
  {
    id: TOR_STATUSES.APPROVED,
    text: TOR_STATUS_LABELS[TOR_STATUSES.APPROVED],
    to: '/time-off-requests/approved',
  },
  {
    id: TOR_STATUSES.DECLINED,
    text: TOR_STATUS_LABELS[TOR_STATUSES.DECLINED],
    to: '/time-off-requests/declined',
  },
  {
    id: TOR_STATUSES.CANCELLED,
    text: TOR_STATUS_LABELS[TOR_STATUSES.CANCELLED],
    to: '/time-off-requests/cancelled',
  },
  {
    id: TOR_STATUSES.SEARCH,
    text: 'Search',
    to: '/time-off-requests/search',
  },
];
